import * as CreditsActions from '~app/actions/credits';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  show: false,
};

function showCredits(state, {show}) {
  return {
    ...state,
    show,
  };
}

const ACTION_HANDLERS = {
  [CreditsActions.SHOW_CREDITS]: showCredits,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/creditsReducer.js